module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/distance-1c0a5b443ec13ea0a6d8aa3869af5547.svg";